__turbopack_context__.v({
  "timer": "AnimatedTimerButtonMobile-module__YcAlJq__timer",
});
